import React, { type ComponentPropsWithoutRef } from 'react';
import noop from 'lodash/noop';
import AsyncCustomFieldContextDeleteModalDI from '@jira/admin-pages__custom-field-context-delete-modal/src/AsyncFieldContextDeleteModal.tsx';
import type CustomFieldContextDeleteModal from '@jira/admin-pages__custom-field-context-delete-modal/src/CustomFieldContextDeleteModal.tsx';
import {
	ContextualAnalyticsData as ContextualAnalyticsDataDI,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import type { ModalProps } from '../../types.tsx';

export type CustomFieldContextDeleteModalOptions = {
	customFieldId: string;
	fieldConfigSchemeId: string;
};

export type Props = ComponentPropsWithoutRef<typeof CustomFieldContextDeleteModal> & ModalProps;

const AsyncCustomFieldContextDelete = ({
	onClose,
	customFieldId,
	fieldConfigSchemeId,
	// @ts-expect-error - TS2339 - Property 'ContextualAnalyticsData' does not exist on type 'Props'.
	ContextualAnalyticsData = ContextualAnalyticsDataDI,
	// @ts-expect-error - TS2339 - Property 'AsyncCustomFieldContextDeleteModal' does not exist on type 'Props'.
	AsyncCustomFieldContextDeleteModal = AsyncCustomFieldContextDeleteModalDI,
}: Props) => {
	const onContextDeleteSuccess = (): void => {
		onClose();

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.location.reload();
	};
	return (
		<ContextualAnalyticsData sourceName="CustomFieldContextDetails" sourceType={SCREEN}>
			<AsyncCustomFieldContextDeleteModal
				customFieldId={customFieldId}
				fieldConfigSchemeId={fieldConfigSchemeId}
				onDeleteSuccess={onContextDeleteSuccess}
				onDeleteFailure={noop}
				onClose={onClose}
			/>
		</ContextualAnalyticsData>
	);
};

export default AsyncCustomFieldContextDelete;
